// extracted by mini-css-extract-plugin
export default {"dataLoading":"redeemContent_dataLoading__dr0Ag"};